<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content"
    header-class="popup_header1"
    body-class="c-body container"
    :visible="visible"
    @hide="hide"
  >
    <template #modal-header="{ close }">
      <span style="margin: auto">{{$t('more.point_history')}}</span>
      <b-img class="mo_close_btn"  @click="hide" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <b-table
      style="font-size: 0.9em;"
      head-variant="my"
      :items="items"
      :fields="fields"
      class="mt-3"
      thead-tr-class="c-header1"
      tbody-tr-class="c-cell"
      bordered>
      <template #cell(ref)="data">
        <b-link style="text-decoration:underline" @click="showSiteDetail(data.value)">{{fields[3].label}}</b-link>
      </template>
    </b-table>
    <p class="p-center" v-if="items.length === 0">{{$t('common.empty_hint')}}</p>
  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
const LOG_TYPE = {
  'C': '충전',
  'O': '차감',
  'A': '제공',
  'U': '사용'
};

export default {
  name: "PointHistoryPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      fields:[
        {key:"date",label:this.$t('more.date'), class:'text-center point-th', thStyle:"flex:19"},
        {key:"history", label:this.$t('more.history'), class:'text-center point-th', thStyle:"flex:14"},
        {key:"inc_or_dec", label:this.$t('more.inc_or_dec'), class:'text-center point-th', thStyle:"flex:16"},
        {key:"remain", label:this.$t('more.remain_point'), class:'text-center point-th', thStyle:"flex:17"},
      ],
      items: [],
      list: [],
    }
  },
  methods:{
    getList(){
      this.items=[];
      Utils.requestGet(this.$c.API.Purchase.getPointLog, {})
        .then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.list= result.data.list;
          }
        });
    },
    hide(){
      this.$emit('update:visible', false);
    },

  },
  computed:{
  },
  watch:{
    visible(){
      if (this.visible){
        this.getList();
      }

    },
    list(){
      for(let it of this.list){
        this.items.push({
          date: moment(it.f_reg_time).format('YYYY/MM/DD'),
          history: LOG_TYPE[it.f_type],
          inc_or_dec: ((LOG_TYPE[it.f_type] == '충전' || LOG_TYPE[it.f_type] == '제공') ? '+' : '-')+ Utils.currency(Math.abs(it.f_point))+' p',
          remain: Utils.currency(parseInt(it.f_point_final))+' p',
        });
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";

.c-header1{
  display: flex;
  font-size: $fs_16;
  font-family: $korean_gd_15_r
}

.c-cell{
  color: $black;
  font-size: $fs_15;
  font-family: $korean_gd_14_r
}

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/PointHistoryPopup.vue